export default __webpack_public_path__ + "static/media/patrick_mcgorry.34b5c9de.jpg";